import { toggle, up, down } from 'slide-element';
import { getElementParents } from '../helpers/general';

document.querySelectorAll('.accordion-header').forEach((header) => {
  header.addEventListener('click', (e) => {
    e.preventDefault();

    const parent = header.parentNode;
    const headerParents = getElementParents(header);
    const parentAccordionBody = parent.querySelector('.accordion-body');

    if (parent.classList.contains('active')) {
      parent.classList.remove('active');
      up(parentAccordionBody);
    } else {
      headerParents.forEach((headerParent) => {
        headerParent.querySelectorAll('.accordion-item').forEach((accordionItem) => {
          accordionItem.classList.remove('active');

          accordionItem.querySelectorAll('.accordion-body').forEach((accordionBody) => {
            if (accordionBody === parentAccordionBody) {
              return;
            }

            up(accordionBody);
          });
        });
      });

      parent.classList.add('active');
      down(parentAccordionBody);
    }
  });
});

document.querySelectorAll('.accordion-title').forEach((accordionTitle) => {
  accordionTitle.addEventListener('click', (e) => {
    e.preventDefault();

    accordionTitle.classList.toggle('active');
    toggle(accordionTitle.nextElementSibling);
  });
});
